/* eslint-disable no-use-before-define */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react-hooks/exhaustive-deps */
import downloadIcon from "./../../media/images/download-grey.png";

import * as Constants from "utils/Constants";
import { downloadFile } from "redux/actions";
import React, { useEffect, useState, useRef } from "react";
import { claimOperations, componentsClaimKey } from "utils/Constants";
import { useDispatch, useSelector } from "react-redux";
import AGGridWrapper from "components/AGGrid/AGGridWrapper";
import GridDataFormater from "utils/GridDataFormater";
import HelperFunctions from "utils/HelperFunctions";
import Select from "react-select";
import { createColumnDef } from "utils/agGridDefaults";
//import imgNotFound from "media/images/image-not-found.jpg";
import { trackPromise } from "react-promise-tracker";

const statusOptions = [
  { value: 1, label: "All" },
  { value: 2, label: "Sent" },
  { value: 3, label: "List Send" },
  { value: 4, label: "Recurring" },
  { value: 5, label: "Paused" },
  { value: 6, label: "Completed" },
  { value: 7, label: "Scheduled" },
  { value: 8, label: "Triggered" },
];

const TableViewComponent = React.forwardRef((props, ref) => {
  const gridWrapperRef = React.useRef(null);
  const { clientUserClaims } = useSelector((state) => state.common);
  const [selectedAction, setSelectedAction] = useState("");
  const [isESPRole, setIsESPRole] = useState(false);
  const { user_information } = useSelector((state) => state.common);
  const [defaultStatusBy, setDefaultStatusBy] = useState({
    value: 1,
    label: "All",
  });
  var currentday = new Date();
  currentday.setHours(0, 0, 0, 0);
  const DefaultPageSize = 10;
  const rowHeight = 90;

  useEffect(() => {
    if (user_information && user_information.roles) {
      let emailRole =
        user_information.roles.filter((a) => a === "Email").length > 0;
      setIsESPRole(emailRole);
    }
  }, [user_information]);

  // Expose refreshColumns method to parent
  React.useImperativeHandle(ref, () => ({
    refreshColumns: () => {
      // For AGGridWrapper, we need to force a complete refresh
      if (gridWrapperRef.current) {
        // Try to access AGGridWrapper's refresh method if available
        if (typeof gridWrapperRef.current.refreshColumns === 'function') {
          gridWrapperRef.current.refreshColumns();
        } else if (gridWrapperRef.current.getGridApi) {
          const gridApi = gridWrapperRef.current.getGridApi();
          const columnApi = gridWrapperRef.current.getColumnApi();
          
          if (gridApi && columnApi) {
            // Force the grid to re-read column state
            gridApi.refreshCells();
            gridApi.resetRowHeights();
            columnApi.resetColumnState();
            gridApi.sizeColumnsToFit();
          }
        }
      }
    }
  }));

  const populateTitle = (params) => {
    if (!params.data) {
      return null;
    }
    var html = (
      <div className="campaing-title-status">
        <div>
          <span className="campaign-title d-block font-weight-bold">
            {params.data.name}
          </span>
          <span
            className={
              "campaign-status " +
              +(params.data.status === Constants.emailStatus.ListSend
                ? "sent"
                : params.data.status?.toLowerCase())
            }
          >
            <span className="status-dot mr-1"></span>
            {params.data.status}
          </span>
        </div>
      </div>
    );

    return html;
  };

  const populateCampaignCategory = (params) => {
    if (!params.data) {
      return null;
    }
    var html = (
      <div className="campaing-category">
        <div>
          <span className="campaign text-break d-block">
            {params.data.playName ? params.data.playName : "Uncategorized"}
          </span>
        </div>
      </div>
    );

    return html;
  };

  const populateThumbnail = (params) => {
    if (!params.data || !params.data.templateID) {
      return null;
    }
    const thumbnail =
      Constants.VNEXT_BASE_URL +
      "shared/GetThumbnail?clientId=" +
      clientId +
      "&id=" +
      params.data.templateID +
      "&module=templates";
    return <img className="w-100 h-100" src={thumbnail} alt="tmp1" />;
  };

  const actionChanged = async (detail, params) => {
    if (params.target.value === "Edit") {
    } else if (params.target.value === "1") {
      props.viewReport(detail);
      //navigate("/EmailDesigner/CampaignReports/" + designId + "/" + props.brandId);
    } else if (params.target.value === "2") {
      await props.handleUnpublishDesign(detail, true);
    } else if (params.target.value === "3") {
      await props.handleRemoveDesign(detail, true);
    } else if (params.target.value == "4") {
      props.preview(detail);
    } else if (params.target.value == "5") {
      props.toggleCampaignSelection(detail);
    } else if (params.target.value == "6") {
      props.draftDesignToSendWizard(detail);
    }
  };

  const populateActions = (params) => {
    if (!params.data) {
      return null;
    }
    return (
      <div id="adhoc-action-wrap">
        <select
          className="browser-default actionSelect form-control"
          onChange={actionChanged.bind(this, params.data)}
          value={selectedAction}
        >
          <option value="" title="" disabled>
            &#xf142;
          </option>
          {params.data.status &&
          params.data.status === Constants.emailStatus.Draft ? (
            <option value="6" title="Continue">
              Continue
            </option>
          ) : null}
          {/*<option value="3" title="Duplicate">
            Duplicate
          </option>*/}
          {HelperFunctions.validateClientUserClaims(
            [
              componentsClaimKey.Designs,
              componentsClaimKey.MarketingPlayConfiguration,
            ],
            claimOperations.Update,
            clientUserClaims
          ) && params.data.emailTemplateEnabled ? (
            <option value="5" title="Move">
              Move
            </option>
          ) : null}
          {params.data.status &&
          (params.data.status === Constants.emailStatus.Recurring ||
            params.data.status === Constants.emailStatus.Paused ||
            params.data.status === Constants.emailStatus.Triggered ||
            params.data.status === Constants.emailStatus.ListSend ||
            params.data.status === Constants.emailStatus.Completed ||
            params.data.status === Constants.emailStatus.Sent) ? (
            <option value="1" title="View Report">
              View Report
            </option>
          ) : null}
          {params.data.status &&
          params.data.status === Constants.emailStatus.Recurring ? (
            HelperFunctions.validateClientUserClaims(
              [
                componentsClaimKey.Designs,
                componentsClaimKey.MarketingPlayConfiguration,
              ],
              claimOperations.Update,
              clientUserClaims
            ) ? (
              <option value="2" title="Unpublish">
                Unpublish
              </option>
            ) : null
          ) : null}
          {params.data.templateID ? (
            <option value="4" title="Preview">
              Preview
            </option>
          ) : null}
        </select>
      </div>
    );
  };

  const populateRevenue = (params) => {
    if (!params.data || params.data.revenue === null || params.data.revenue === undefined) {
      return '';
    }
    return HelperFunctions.formateNumberbyCommas(
      params.data.revenue,
      true,
      0,
      true
    );
  };

  const populateLastSentDate = (params) => {
    if (!params.data || !params.data.lastSentDate) {
      return null;
    }
    return (
      <span
        dangerouslySetInnerHTML={{
          __html: GridDataFormater.formatDateWithTimeWithLineBreak(
            params.data.lastSentDate
          ),
        }}
      />
    );
  };

  const populateNextSendDate = (params) => {
    if (!params.data || !params.data.nextSendDate) {
      return null;
    }
    return (
      <span
        dangerouslySetInnerHTML={{
          __html: GridDataFormater.formatDateWithTimeWithLineBreak(
            params.data.nextSendDate
          ),
        }}
      />
    );
  };

  const populateEndDate = (params) => {
    if (!params.data || !params.data.endDate) {
      return null;
    }
    return (
      <span
        dangerouslySetInnerHTML={{
          __html: GridDataFormater.vNextformatDateTimefromUTC({
            value: params.data.endDate,
          }),
        }}
      />
    );
  };

  const columnDefsOrignal = [
    // Actions column - special column that doesn't use createColumnDef
    {
      headerName: "",
      hide: false,
      cellStyle: { textAlign: "center" },
      width: 50,
      lockPosition: true,
      cellRenderer: populateActions,
      pinned: "left",
      customOrder: 0,
      suppressMovable: true,
      sortable: false,
      filter: false,
      resizable: false,
    },
    // Title column with custom renderer
    createColumnDef({
      headerName: "Title",
      field: "name",
      hide: false,
      fieldType: "text",
      customOrder: 1,
      cellRenderer: populateTitle,
      pinned: "left",
      lockPosition: true,
      maxWidth: 2000,
      suppressMovable: true,
    }),
    createColumnDef({
      headerName: "Bounce Rate",
      field: "bounceRate",
      hide: true,
      fieldType: "number",
      customOrder: 2,
      valueFormatter: GridDataFormater.formatPercentageNoDecimal,
    }),
    createColumnDef({
      headerName: "Bounces",
      field: "bounced",
      hide: true,
      fieldType: "number",
      customOrder: 3,
      valueFormatter: GridDataFormater.formatNumber,
    }),
    createColumnDef({
      headerName: "Campaign Category",
      field: "playName",
      hide: false,
      fieldType: "text",
      customOrder: 4,
      cellRenderer: populateCampaignCategory,
      pinned: "left",
      lockPosition: true,
      wrapText: true,
      minWidth: 140,
      maxWidth: 150,
      suppressMovable: true,
    }),
    createColumnDef({
      headerName: "Click Rate",
      field: "clickRate",
      hide: false,
      fieldType: "number",
      customOrder: 5,
      valueFormatter: GridDataFormater.formatPercentageNoDecimal,
    }),
    createColumnDef({
      headerName: "Clicks",
      field: "clicked",
      hide: true,
      fieldType: "number",
      customOrder: 6,
      valueFormatter: GridDataFormater.formatNumber,
    }),
    createColumnDef({
      headerName: "Delivered",
      field: "totalDelivered",
      hide: true,
      fieldType: "number",
      customOrder: 7,
      valueFormatter: GridDataFormater.formatNumber,
    }),
    createColumnDef({
      headerName: "Delivered Rate",
      field: "deliveredRate",
      hide: true,
      fieldType: "number",
      customOrder: 8,
      valueFormatter: GridDataFormater.formatPercentageNoDecimal,
    }),
    createColumnDef({
      headerName: "End Date",
      field: "endDate",
      hide: true,
      fieldType: "date",
      customOrder: 9,
      cellRenderer: populateEndDate,
    }),
    createColumnDef({
      headerName: "Last Sent",
      field: "lastSentDate",
      hide: false,
      fieldType: "date",
      customOrder: 10,
      cellRenderer: populateLastSentDate,
      initialSort: "desc",
    }),
    createColumnDef({
      headerName: "Marketing Play ID",
      field: "marketingPlayId",
      hide: true,
      fieldType: "number",
      customOrder: 11,
    }),
    createColumnDef({
      headerName: "Next Send Date",
      field: "nextSendDate",
      hide: true,
      fieldType: "date",
      customOrder: 12,
      cellRenderer: populateNextSendDate,
    }),
    createColumnDef({
      headerName: "Open Rate",
      field: "openRate",
      hide: false,
      fieldType: "number",
      customOrder: 13,
      valueFormatter: GridDataFormater.formatPercentageNoDecimal,
    }),
    createColumnDef({
      headerName: "Opens",
      field: "opened",
      hide: true,
      fieldType: "number",
      customOrder: 14,
      valueFormatter: GridDataFormater.formatNumber,
    }),
    createColumnDef({
      headerName: "Recurrence",
      field: "recurrence",
      hide: true,
      fieldType: "text",
      customOrder: 15,
    }),
    createColumnDef({
      headerName: "Recurrence Details",
      field: "recurrenceDetails",
      hide: true,
      fieldType: "text",
      customOrder: 16,
    }),
    createColumnDef({
      headerName: "Revenue",
      field: "revenue",
      hide: false,
      fieldType: "number",
      customOrder: 17,
      cellRenderer: populateRevenue,
    }),
    createColumnDef({
      headerName: "Schedule Type",
      field: "type",
      hide: false,
      fieldType: "text",
      customOrder: 18,
    }),
    createColumnDef({
      headerName: "Source",
      field: "source",
      hide: true,
      fieldType: "text",
      customOrder: 19,
      wrapText: true,
      minWidth: 120,
      maxWidth: 150,
    }),
    createColumnDef({
      headerName: "Subject Line",
      field: "subject",
      hide: false,
      fieldType: "text",
      customOrder: 20,
      wrapText: true,
      minWidth: 300,
      maxWidth: 500,
    }),
    createColumnDef({
      headerName: "Template ID",
      field: "templateID",
      fieldType: "text",
      hide: true,
      customOrder: 21
    }),
    createColumnDef({
      headerName: "Thumbnail",
      field: "thumb",
      fieldType: "text",
      hide: false,
      width: 100, // Fixed width for thumbnails makes sense
      cellStyle: { textAlign: "center" },
      cellRenderer: populateThumbnail,
      customOrder: 22,
      sortable: false,
      filter: false,
    }),
    createColumnDef({
      headerName: "Total Sent",
      field: "totalSent",
      fieldType: "number",
      hide: false,
      customOrder: 23,
      valueFormatter: GridDataFormater.formatNumber,
    }),
    createColumnDef({
      headerName: "Unsubscribe Rate",
      field: "unsubscribeRate",
      fieldType: "number",
      hide: true,
      valueFormatter: GridDataFormater.formatPercentageNoDecimal,
      customOrder: 24
    }),
    createColumnDef({
      headerName: "Unsubscribes",
      field: "unsubscribed",
      fieldType: "number",
      hide: true,
      valueFormatter: GridDataFormater.formatNumber,
      customOrder: 25
    }),
  ];

  const dispatch = useDispatch();
  const [exportURL, setExportURL] = useState("");
  const [clientId, setClientId] = useState(
    HelperFunctions.getCookie("selectedClientId")
  );
  const [gridApi, setGridApi] = useState(null);
  const [gridColumnApi, setGridColumnApi] = useState(null);
  const [columnChooserItems, setColumnChooserItems] = useState([]);
const { manage_campaign_detail } = useSelector(
    (state) => state.marketingPlayReports
  );
  const [emailDetails, setEmailDetails] = useState(null);
  const [searchText, setSearchText] = useState("");
  const [includeNoRevenue, setIncludeNoRevenue] = useState(true);
  const [tabelViewColumns, setTabelViewColumns] = useState(props.columnDefs || columnDefsOrignal);

  useEffect(() => {
    var element = document.getElementsByClassName("body-container")[0];
    element?.addEventListener(
      "scroll",
      (e) => {
        if (e.target.scrollTop > 0) {
          document
            .querySelector(".marketing-play")
            ?.classList.add("s-collapse");
          document.querySelector(".adhoc-grid")?.classList.add("s-collapse");
        } else {
          document
            .querySelector(".marketing-play")
            ?.classList.remove("s-collapse");
          document.querySelector(".adhoc-grid")?.classList.remove("s-collapse");
        }
        // setScroll(e.target.scrollTop > 0)
      },
      { passive: true }
    );
    let _columns = [...props.columnDefs];

    // loop through _columns
    _columns.forEach((c) => {
      if (c.field === "playName") {
        c.hide = false;
      }
    });

    // Then sort
    _columns.sort(HelperFunctions.compare);

    // Finaly set them in state
    setTabelViewColumns(_columns);

    return () =>
      window.removeEventListener("scroll", (e) => {
        // setScroll(e.target.scrollTop > 0)
      });
  }, []);

  useEffect(() => {
    let _columns = [...props.columnDefs];

    // loop through _columns
    _columns.forEach((c) => {
      if (c.field === "playName") {
        c.hide = false;
      }
    });

    // Then sort
    _columns.sort(HelperFunctions.compare);

    // Finally set them in state
    setTabelViewColumns(_columns);

    setExportURL(
      Constants.VNEXT_BASE_URL +
        "Report/MarketingPlayReports/ManageCampaignGetDetailExport?clientId=" +
        clientId +
        "&searchText=" +
        searchText +
        "&status=" +
        (defaultStatusBy.label !== "All" ? defaultStatusBy.label : "") +
        "&withNoRevenues=" +
        includeNoRevenue +
        "&startDate=" +
        (props.startDate ? props.startDate : "") +
        "&endDate=" +
        (props.endDate ? props.endDate : "") +
        "&isExport=true&format=xlsx&selectedFields=" +
        _columns
          .filter((c) => {
            return c.field !== "thumb" && c.field && !c.hide;
          })
          .map((a) => a.field)
    );

    if (gridApi && gridColumnApi) {
      if (gridApi) {
        gridApi.setGridOption(
          "columnDefs",
          _columns?.sort(HelperFunctions.compare)
        );
      }

      // Let the flex: 1 auto-sizing handle column widths instead of calling autoSizeAllColumns
      // The createColumnDef function now sets flex: 1 for auto-sizing columns
    }
  }, [props.columnDefs]);

  //#region Ag Grid

  function onGridReady(params) {
    setGridApi(params.api);
    setGridColumnApi(params.columnApi);
    //params.api.autoSizeAllColumns();
  }

  const updateGridData = () => {
    var text = searchText == "" ? searchText : searchText?.toLowerCase();
    if (gridApi) {
      gridApi.setGridOption("quickFilterText", text);
    }
  };

  useEffect(() => {
    updateGridData();
  }, [searchText]);

  // useEffect(() => {
  //   //trackPromise(dispatch(ManageCampaignGetDetail(startDate, endDate, clientId, true)));
  //   setSelecetedDropdownValues(columnDefs);
  // }, [clientId, props.startDate, props.endDate]);

  useEffect(() => {
    setExportURL(
      Constants.VNEXT_BASE_URL +
        "Report/MarketingPlayReports/ManageCampaignGetDetailExport?clientId=" +
        clientId +
        "&searchText=" +
        searchText +
        "&status=" +
        (defaultStatusBy.label !== "All" ? defaultStatusBy.label : "") +
        "&withNoRevenues=" +
        includeNoRevenue +
        "&startDate=" +
        (props.startDate ? props.startDate : "") +
        "&endDate=" +
        (props.endDate ? props.endDate : "") +
        "&isExport=true&format=xlsx&selectedFields=" +
        columnChooserItems
          .filter((c) => {
            return c.value !== "thumb" && c.value;
          })
          .map((a) => a.value)
    );
  }, [columnChooserItems]);

  useEffect(() => {
    setEmailDetails(manage_campaign_detail?.details);
  }, [manage_campaign_detail]);

  useEffect(() => {
    setExportURL(
      Constants.VNEXT_BASE_URL +
        "Report/MarketingPlayReports/ManageCampaignGetDetailExport?clientId=" +
        clientId +
        "&searchText=" +
        searchText +
        "&status=" +
        (defaultStatusBy.label !== "All" ? defaultStatusBy.label : "") +
        "&withNoRevenues=" +
        includeNoRevenue +
        "&startDate=" +
        (props.startDate ? props.startDate : "") +
        "&endDate=" +
        (props.endDate ? props.endDate : "") +
        "&isExport=true&format=xlsx&selectedFields=" +
        tabelViewColumns
          ?.filter((c) => {
            return c.field !== "thumb" && c.field && !c.hide;
          })
          .sort(HelperFunctions.compare)
          .map((a) => a.field)
    );
  }, [includeNoRevenue]);

  const onExcelExportButtonClick = () => {
    var stDate = props.startDate ? new Date(props.startDate) : "";
    var edDate = props.startDate ? new Date(props.endDate) : "";
    var fromAndToDate = "";
    if (stDate && edDate) {
      fromAndToDate = `_${
        stDate.getMonth() + 1
      }-${stDate.getDate()}-${stDate.getFullYear()}_${
        edDate.getMonth() + 1
      }-${edDate.getDate()}-${edDate.getFullYear()}`;
    }
    var fileName = `CampaignData${fromAndToDate}_${new Date().getTime()}`;
    trackPromise(dispatch(downloadFile(exportURL, fileName, "xlsx")));
  };

  //#endregion

  //#region UnPublish
  const applyFilter = (selectedStatusOption, selectedIncludeNoRevenue) => {
    if (selectedStatusOption.value != "1") {
      setEmailDetails(
        manage_campaign_detail?.details?.filter(
          (a) =>
            a.status != null &&
            a.status?.toLowerCase() ==
              selectedStatusOption.label?.toLowerCase() &&
            (selectedIncludeNoRevenue || a.revenue > 0)
        )
      );
    } else {
      setEmailDetails(
        manage_campaign_detail?.details?.filter(
          (a) => selectedIncludeNoRevenue || a.revenue > 0
        )
      );
    }
  };

  const onChangeStatus = (e) => {
    setDefaultStatusBy(e);
    setExportURL(
      Constants.VNEXT_BASE_URL +
        "Report/MarketingPlayReports/ManageCampaignGetDetailExport?clientId=" +
        clientId +
        "&searchText=" +
        searchText +
        "&status=" +
        (e.label !== "All" ? e.label : "") +
        "&withNoRevenues=" +
        includeNoRevenue +
        "&startDate=" +
        (props.startDate ? props.startDate : "") +
        "&endDate=" +
        (props.endDate ? props.endDate : "") +
        "&isExport=true&format=xlsx&selectedFields=" +
        tabelViewColumns
          ?.filter((c) => {
            return c.field !== "thumb" && c.field && !c.hide;
          })
          .sort(HelperFunctions.compare)
          .map((a) => a.field)
    );
    applyFilter(e, includeNoRevenue);
  };

  const onChangeIncludeNoRevenue = (e) => {
    setIncludeNoRevenue(e?.target?.checked);
    applyFilter(defaultStatusBy, e?.target?.checked);
  };

  const searchHandleChange = (e) => {
    if (e.target.value != "") {
      setSearchText(e.target.value);
    } else {
      setSearchText("");
    }
  };

  return (
    <>
      <div id="marketing-plays-detail" className="p-0">
        <div className="row">
          <div className="col-lg-12 marketing-play">
            <div className="parent-filter-div">
              <div style={{ flexDirection: "row" }}>
                <div className="col-lg-12">
                  <div className="campaign-filters d-flex justify-content-between py-0">
                    <div className="d-inline-flex">
                      <div className="search-field">
                        <label htmlFor="search-bar" className="input-style m-0">
                          <input
                            className="searchbar-input w-100"
                            id="search-bar"
                            name="searchValue"
                            type="search"
                            onChange={searchHandleChange}
                            value={searchText}
                            //onKeyPress={keyPressed}
                            placeholder="Search..."
                          />
                        </label>
                      </div>
                      {isESPRole ? (
                        <div className="sort-filter d-flex align-items-center mr-auto mx-3">
                          <label className="status-by-label mr-2 mb-0">
                            Status By:{" "}
                          </label>
                          <Select
                            options={statusOptions}
                            classNamePrefix="sort-select"
                            className="sort-select"
                            value={defaultStatusBy}
                            onChange={(e) => {
                              onChangeStatus(e);
                            }}
                            placeholder="All"
                          />
                        </div>
                      ) : null}

                      <div className="sort-filter d-flex align-items-center mr-auto mx-2">
                        <input
                          type="checkbox"
                          className="mr-1"
                          defaultChecked={includeNoRevenue}
                          onClick={(e) => onChangeIncludeNoRevenue(e)}
                        ></input>
                        <label className="sort-by-label text-nowrap mb-0">
                          {" "}
                          Include Rows with No Revenue
                        </label>
                      </div>
                    </div>
                    <div className="d-inline-flex">
                      <div
                        onClick={onExcelExportButtonClick}
                        className="sort-filter cursor-pointer d-flex align-items-center mx-2 download-manage-campaign"
                      >
                        <img
                          className="mb-2 mr-2"
                          src={downloadIcon}
                          alt="download"
                        />
                        <label className="cursor-pointer text-nowrap mr-2">
                          Download
                        </label>
                      </div>
                      <div className="sort-filter cursor-pointer d-flex align-items-center edit-columns mx-2">
                        <button
                          type="button"
                          onClick={() => {
                            if (gridWrapperRef.current?.openManageColumns) {
                              gridWrapperRef.current.openManageColumns();
                            }
                          }}
                        >
                          <span>Manage Columns</span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-12 ag-grid-container">

            <AGGridWrapper
              ref={gridWrapperRef}
              preset="advanced"
              enableManageColumns={true}
              clientId={clientId}
              disabledFields={["", "name"]}
              entityName={Constants.MANAGE_COLUMN_ENTITIES.ManageCampaigns}
              columnDefs={tabelViewColumns}
              onGridReady={onGridReady}
              rowData={emailDetails}
              rowHeight={60} // Max Row Height: 60px as specified
              enableCellTextSelection={true}
              pagination={true}
              paginationPageSize={10} // Page Size: 10 as specified
              headerHeight={54}
              groupHeaderHeight={54}
              gridOptions={{
                detailRowAutoHeight: true, // detailRowAutoHeight=true as specified
                defaultColDef: {
                  cellStyle: {
                    display: 'flex',
                    alignItems: 'center', // Text vertically centered as specified
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                  }
                }
              }}
            />
          </div>
        </div>
      </div>
    </>
  );
});

TableViewComponent.displayName = 'TableViewComponent';

export default TableViewComponent;
